import { getQualifiedFlexDates, validateFlexDate } from '@pcln/fly-listings'
import flyinImageVariant1 from '../../../public/assets/images/flyin_image_variant1.png'

export function flexDatesFlyinHelper(
  flexDates,
  minRetailPrice,
  departDate,
  returnDate,
  origin,
  destination
) {
  const flexDatesHelperResults = {
    flexDatesFlyinText: '',
    flexDatesFlyinLink: '',
    isFlexDatesFlyin: false
  }
  const qualifiedFlexDates =
    getQualifiedFlexDates(
      minRetailPrice,
      flexDates,
      departDate,
      returnDate,
      3
    ) || []

  if (qualifiedFlexDates.length === 1) {
    const {
      retailAltPriceDiff,
      formatDepartDate,
      formatReturnDate,
      lengthOfStayText,
      newSearchUrl
    } = validateFlexDate(
      qualifiedFlexDates[0],
      minRetailPrice,
      origin,
      destination
    )

    flexDatesHelperResults.isFlexDatesFlyin = true
    flexDatesHelperResults.flexDatesFlyinLink = newSearchUrl
    flexDatesHelperResults.flexDatesFlyinText = `Fly a different day. Save $${retailAltPriceDiff}!`
    flexDatesHelperResults.flexDatesFlyinText2 = `${formatDepartDate} - ${formatReturnDate} (${lengthOfStayText})`
    flexDatesHelperResults.flexDatesFlyinImage = flyinImageVariant1
  }
  return flexDatesHelperResults
}
